// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","content":"Loader_content__nFjf0","numbers":"Loader_numbers__v2QAe"};